import { inject, Injectable } from "@angular/core";
import { ApiUrlConfigurationService } from "../../core/config/api-url-configuration.service";
import { ApiVersionService } from "../../core/http/api-version.service";
import { AuthTokenStore } from "../stores/auth-token-store";
import { mobileSoftwareUpgradeEndPoint } from "../../../assets/data/softwareupgradeconstant";

@Injectable({
  providedIn: "root"
})
export class SessionLogoutService {
  private apiUrlConfigurationService = inject(ApiUrlConfigurationService);
  private versionService = inject(ApiVersionService);
  private authTokenStore = inject(AuthTokenStore);
  terminateSession() {
    const apiBaseUrl = this.apiUrlConfigurationService.getApiEndpoint();
    const version = this.versionService.getVersion();
    const accessToken = this.authTokenStore.getAccessToken();
    if (!accessToken) {
      return;
    }
    const url = `${apiBaseUrl}/api/${version}/${mobileSoftwareUpgradeEndPoint.userManagementAPI.logOutUser}`;
    const payload = JSON.stringify({ authorization: accessToken });
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "Content-Type": "application/json"
      },
      body: payload,
      keepalive: true
    }).catch(() => {
      this.useSendBeacon(url, payload);
    });
  }

  private useSendBeacon(url: string, payload: string) {
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" });
      navigator.sendBeacon(url, blob);
    }
  }
}
